import { AlertTriangle, CheckCircle2, Circle, Info, XCircle, type LucideIcon } from 'lucide-react';

export type Tone = 'neutral' | 'primary' | 'info' | 'success' | 'warning' | 'danger';

/** Default icon per tone so status is never conveyed by colour alone (R-5.7). */
export const TONE_ICONS: Record<Tone, LucideIcon> = {
  neutral: Circle,
  primary: Circle,
  info: Info,
  success: CheckCircle2,
  warning: AlertTriangle,
  danger: XCircle,
};
